import LOGO from '../../assets/logos/jacc.svg';

const jacc = {
    name: 'JACC',
    type: 'project',
    logo: {
        image: LOGO,
        height: '5em'
    },
    background: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/project%2Fjacc%2Fnme-gif-jacc.gif?alt=media&token=cc7765cd-61a8-4b9b-ae14-fbb6dd5bef5d',
    heading: 'The greatest architectural marvel, and the largest of its kind in the region, refines architecture in Kuwait...',
    blurb: 'The greatest architectural marvel, and the largest of its kind in the region, refines architecture in Kuwait...',
    text: {
        1: 'Jaber Al Ahmed Cultural Center, the greatest architectural marvel and the largest of its kind in the region. The design, attention to detail, and emphasis on it’s outdoor versus indoor experiences has allowed it to be one of the benchmarks that redefines architecture in Kuwait.',
        2: 'Aiming to entertain, educate, and inspire the people of Kuwait, JACC’s mission was to perfect it’s architecture down to the last detail. It hired and commissioned only the best to help put together the architectural marvel standing today. NME was proud to fabricate and install Solarlux facades in all of the restaurants in JACC.'
    },
    video: 'https://www.youtube.com/watch?v=TFnqaeqpkQg',
    website: 'http://jacc-kw.com',
};

export default jacc;



// WEBPACK FOOTER //
// ./src/data/project/jacc.js